<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{ mode }}] {{ $t('group') }}
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Save" class="p-button-success" @click="confirm($event)"
                            v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <TabView>
                        <TabPanel header="Header Groups">
                            <div class="grid">
                                <div class="col-6">
                                    <!-- <div class="field grid">
                                        <label for="Code" class="col-4">{{ $t('code') }}</label>
                                        <div class="col-6 md-6">
                                            <InputText name="Code" v-model="header.Code" type="text" :placeholder="$t('code')"
                                                v-if="header" :class="{ 'p-invalid': submitted && !header.Code }"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                :readonly="mode != this.$FORM_MODE_CREATE" />
                                            <Skeleton v-else-if="!header" />
                                            <small v-if="header && !header.Code && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('code')) }}
                                            </small>
                                        </div>
                                    </div> -->

                                    <FormField :labelName="$t('Job_Role')" fieldName="Job_Position" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <CustomSelect 
                                            class="p-inputtext-sm" 
                                            v-model="header.Job_Position" 
                                            :url="this.$API_URL + 'list/lookup'" 
                                            :minLength="0" 
                                            :params="{ group : $LOOKUP_GROUP.APPROVAL_AS_MATRIX }" 
                                            v-if="header" 
                                            :disabled="mode != this.$FORM_MODE_CREATE"
                                            :filter="true"
                                            />
                                            <small
                                            v-if="header && !header.Job_Position && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('Job_Role')) }}
                                        </small>
                                    </FormField>

                                    <div class="field grid">
                                        <label for="Description" class="col-4">{{ $t('description') }}</label>
                                        <div class="col-8 md-8">
                                            <InputText name="Description" v-model="header.Description" type="text"
                                                :placeholder="$t('description')" v-if="header"
                                                :class="{ 'p-invalid': submitted && !header.Description }"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                            <Skeleton v-else-if="!header" />
                                            <small
                                                v-if="header && !header.Description && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('description')) }}
                                            </small>
                                        </div>
                                    </div>

                                    <FormField :labelName="$t('all_location')" fieldName="All_Location" v-model="header" labelClass="col-4" fieldClass="col-6 md-6" v-if="header">
                                        <Checkbox v-model="header.All_Location" :disabled="!canEdit" v-if="header" :binary="true" @change="onChangeAllLocation()"/>
                                    </FormField> 

                                    <FormField :labelName="$t('Administrator')" fieldName="Administrator" v-model="header" labelClass="col-4" fieldClass="col-6 md-6" v-if="header">
                                        <Checkbox v-model="header.Administrator" :disabled="!canEdit" v-if="header" :binary="true"/>
                                    </FormField> 

                                    <FormField :labelName="$t('UpdateWO')" fieldName="UpdateWO" v-model="header" labelClass="col-4" fieldClass="col-6 md-6" v-if="header">
                                        <Checkbox v-model="header.Is_Update_Wo " :disabled="!canEdit" v-if="header" :binary="true"/>
                                    </FormField> 

                                </div>
                                
                                <div class="col-6">
                                    <FormField :labelName="$t('reason')" fieldName="Reason" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="mode != this.$FORM_MODE_CREATE">
                                        <InputText name="Reason" v-model="header.Reason" required="true" type="text"
                                            :placeholder="$t('reason')" v-if="header"
                                            :disabled="mode != this.$FORM_MODE_EDIT"/>
                                            <small v-if="header &&((!header.Reason && mode == this.$FORM_MODE_EDIT)) && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                            </small>
                                    </FormField>
                                </div>

                                <div class="col-12">
                                    <DataTable :loading="!header" :value="header ? header.Details : null" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table" :rowClass="hideRow">
                                        <Column >
                                            <template #header>
                                                <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm" @click="addDetail"  :disabled="!canEdit" />
                                            </template>
                                            <template #body="slotProps">
                                                <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm" @click="deleteDetail(slotProps)"  :disabled="!canEdit"/>
                                            </template>
                                        </Column>
                                        <Column field="Menu_Id" :header="$t('menu')" key="Menu_Id" class="w-12">
                                            <template #body="slotProps">
                                                <CustomSelect 
                                                    v-model="slotProps.data[slotProps.column.props.field]" 
                                                    :url="$API_URL + 'list/menu'" 
                                                    :minLength="0" 
                                                    :filter="true"
                                                    :disabled="!canEdit"
                                                    :params="{ exclude_menus: this.excludeMenus(slotProps.index)}"
                                                    @change="onCellEditComplete(slotProps)" 
                                                    />
                                            </template>  
                                        </Column>
                                        <Column field="View" :header="$t('view')">
                                            <template #body="slotProps">
                                                <Checkbox v-model="slotProps.data.View" :binary="true" :disabled="!canEdit" @change="onCellEditComplete(slotProps)" />
                                            </template>
                                        </Column>
                                        <Column field="Edit" :header="$t('edit')">
                                            <template #body="slotProps">
                                                <Checkbox v-model="slotProps.data.Edit" :binary="true" :disabled="!canEdit" @change="onCellEditComplete(slotProps)" />
                                            </template>
                                        </Column>
                                        <Column field="Delete" :header="$t('delete')">
                                            <template #body="slotProps">
                                                <Checkbox v-model="slotProps.data.Delete" :binary="true" :disabled="!canEdit" @change="onCellEditComplete(slotProps)" />
                                            </template>
                                        </Column>
                                        <Column field="Create" :header="$t('create')">
                                            <template #body="slotProps">
                                                <Checkbox v-model="slotProps.data.Create" :binary="true" :disabled="!canEdit" @change="onCellEditComplete(slotProps)" />
                                            </template>
                                        </Column>
                                        <Column field="Print" :header="$t('print')">
                                            <template #body="slotProps">
                                                <Checkbox v-model="slotProps.data.Print" :binary="true" :disabled="!canEdit" @change="onCellEditComplete(slotProps)" />
                                            </template>
                                        </Column>
                                        <Column field="Only_Draft" :header="$t('only_draft')">
                                            <template #body="slotProps">
                                                <Checkbox v-model="slotProps.data.Only_Draft" :binary="true" :disabled="!canEdit" @change="onCellEditComplete(slotProps)" />
                                            </template>
                                        </Column>
                                        
                                    </DataTable>
                                </div>
                                
                                    <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
                                        <TabView>
                                            <TabPanel :header="$t('log_history')">
                                                <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                                    :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                            </TabPanel>
                                             <TabPanel :header="$t('Change_History')">
                                                <ChangeHistory v-if="this.header" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode"></ChangeHistory>
                                            </TabPanel>
                                        </TabView>
                                    </div>  

                            </div>
                        </TabPanel>
                        <TabPanel :header="$t('location')" v-if="header && !hidelocation">
                            <Locations :dataArray="header.Locations" :dataModel="locationModel" :isAuth="false" v-if="header" :header="header" :mode="mode"/>
                        </TabPanel>
                    </TabView>
                   
                </div>
            </template>
        </Card>
    </form>
</template>


<script>
 import Locations from './_Locations.vue';
export default {
    name: "Editor",
    components: {
            Locations: Locations
        },
    data() {
        return {
            indexName: "GroupIndex",
            url: this.$API_URL + "group/",
            header: null,
            detail: null,
            mode: "",
            submitted: false,
            id: 0,
            formEditable: true,
            locationModel : null,
            hidelocation : false,
            dataChangesLog:this.$dataChangesLogMasterData,
            detailLog : null,
            dataModelReqLogs: [],
            dataRequestLogs: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Action By" },
                //{ field: "Table_Name", header: "Table Name" },
                { field: "Action", header: "Action" },
                { field: "Action_Date", header: "Action Date" },
                { field: "Notes", header: "Notes" },
            ],
        }
    },
    methods: {
        onChangeAllLocation(){
            if(this.hidelocation == true)
                this.hidelocation = false;
            else
                this.hidelocation = true;

            //this.header.Location_Code = null;
        },
        excludeMenus(index){
            var excludes = [];
            var details = this.header.Details;

            for(var i=0; i< details.length;i++){
                var detail = details[i];
                if(detail.Menu_Id != 0 && detail.Menu_Id != undefined)
                    excludes.push(detail.Menu_Id);                
            }
            return excludes.join(";");
        },
        onChangeAllMode(data){
            if(!data.Create || !data.Edit || !data.Delete || !data.Print || !data.View) 
                data.cek_all = false;
            else
                data.cek_all = true;
        },
        onChangeIsCheck(data){
           // this.header.Details.forEach((data)=>{
                if(data.cek_all){
                    data.Create  =true;
                    data.Edit  =true;
                    data.Delete  =true;
                    data.Print  =true;
                    data.View  =true;
                    
                }else{
                    data.Create  =false;
                    data.Edit  =false;
                    data.Delete  =false;
                    data.Print  =false;
                    data.View  =false;
                } 
           // });
        },
        getData() {
            var self = this;
            this.$axios.get(this.url + this.id + "/" + this.mode)
                .then((response) => {
                    self.header = response.data.data.header;
                    self.header.mode = self.mode;
                    self.detail = response.data.data.detail;
                    self.dataModelReqLogs = response.data.data.header.request_log;
                    self.locationModel = response.data.data.location;
                    self.hidelocation = self.header.All_Location;
                    self.detailLog = self.header.DetailLog;
                })
                .catch(function (error) {
                    alert(error);
                });
        },
        saveData() {
            this.$emit('block-ui');
            var self = this;
            this.$axios.post(this.url, this.header)
                .then((response) => {
                    if (response.data.success) {
                        if(self.header.mode == self.$FORM_MODE_CREATE)
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Group " + self.header.Job_Position + " has been Create successfully", life: 3000 } });
                        else if(self.header.mode == self.$FORM_MODE_EDIT)
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Group " + self.header.Job_Position + " has been Edit successfully", life: 3000 } });
                        else if(self.header.mode == self.$FORM_MODE_DELETE)
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Group " + self.header.Job_Position + " has been Delete successfully", life: 3000 } });
                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            this.$router.push({ path: "/Group/Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            //!this.header.Code 

           

            if (!this.header.Description || !this.header.Job_Position || (!this.header.Reason && this.mode == this.$FORM_MODE_EDIT)) {
                return;
            }
            else if(this.header.Locations.length == 0 && !this.header.All_Location){
                this.showError('Error Saving Data', 'Must have at least one location');
                return;
            }
            else {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Are you sure?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.saveData();
                    },
                    reject: () => {
                        //callback to execute when user rejects the action
                    }
                });
            }
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetail() {
            var newDetail = this.detail;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.Details.push(det);
        },
        deleteDetail(event) {
            if (event) {
                var detail = this.header.Details[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.Details.splice(this.header.Details.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete(event) {
            this.editDetail(event.index);
        },
        editDetail(index) {
            if (this.header && this.header.Details) {
                let mode = this.header.Details[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Details[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
    },
    computed:{
        canEdit(){
            return this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT;
        }
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;

        this.getData();
    }
}
</script>